var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134.38 135.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "119.99 19.29 80.23 19.29 80.23 55.91",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "99.59 9.35 71.34 9.35 71.34 54.86",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.59,
    cy: 9.35,
    r: 2.62,
    style: {
      fill: "#b2dbf7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 39.46,
    cy: 39.46,
    r: 34.78,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.46,
    cy: 39.46,
    r: 24.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.49,27.42c6.65,6.65,6.65,17.42,0,24.07",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.42,51.49c-6.65-6.65-6.65-17.42,0-24.07",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.46,
    cy: 39.46,
    r: 2.96,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.25,
    y1: 12.25,
    x2: 17.48,
    y2: 17.48,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.43,
    y1: 61.43,
    x2: 66.66,
    y2: 66.66,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.66,
    y1: 12.25,
    x2: 61.43,
    y2: 17.48,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.54,
    y1: 39.72,
    x2: 52.14,
    y2: 39.72,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.25,
    y1: 39.72,
    x2: 18.85,
    y2: 39.72,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.2,
    y1: 60.07,
    x2: 39.2,
    y2: 52.67,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.2,
    y1: 26.77,
    x2: 39.2,
    y2: 19.37,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.48,
    y1: 61.43,
    x2: 12.25,
    y2: 66.66,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.46,
    y1: 77.93,
    x2: 39.46,
    y2: 70.53,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.46,
    y1: 8.38,
    x2: 39.46,
    y2: 0.98,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.46,
    y1: 77.93,
    x2: 39.46,
    y2: 70.53,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.46,
    y1: 8.38,
    x2: 39.46,
    y2: 0.98,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.98,
    y1: 39.46,
    x2: 8.38,
    y2: 39.46,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.53,
    y1: 39.46,
    x2: 77.93,
    y2: 39.46,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.82,
    cy: 58.82,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.72,
    cy: 56.72,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.63,
    cy: 54.63,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.81,
    cy: 24.81,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.71,
    cy: 22.71,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.62,
    cy: 20.62,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.62,
    cy: 58.82,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.71,
    cy: 56.72,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.81,
    cy: 54.63,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.63,
    cy: 24.81,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.72,
    cy: 22.71,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.82,
    cy: 20.62,
    r: 0.74,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.12,
    y1: 35.79,
    x2: 41.55,
    y2: 37.36,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.36,
    y1: 41.55,
    x2: 35.79,
    y2: 43.12,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.12,
    y1: 43.12,
    x2: 41.55,
    y2: 41.55,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.36,
    y1: 37.36,
    x2: 35.79,
    y2: 35.79,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 118.16,
    cy: 75.27,
    r: 2.62,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "92.01 94.1 115.55 94.1 115.55 106.13 120.78 106.13",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.01,
    y1: 89.91,
    x2: 126.53,
    y2: 89.91,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "86.77 86.25 119.21 86.25 119.21 81.54 127.05 81.54 127.05 75.27 120.78 75.27",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.05,
    cy: 89.91,
    r: 2.62,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.35,
    cy: 106.13,
    r: 2.62,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.84,91.79c-.14,3.99-1.67,11.77-4.85,12.61-3.42,.9-5.89,.99-11.8-.3-1.23-.19-2.46-.29-3.7-.3-.22,0-.4-.19-.4-.41,0-2.03,0-11.01,0-12.55,0-.13,.06-.25,.16-.32,.8-.57,1.29-2.07,2.15-2.85,1.63-1.46,2.87-1.89,3.97-2.72,1.88-1.42,2.22-3.22,2.82-4.63,.49-1.16,1.29-1.99,2.5-1.45,1.22,.54,2.48,2.75,.96,5.89-.44,.91-1.08,1.57-1.66,3.18-.13,.37-.16,.96,.26,.94,2.38-.18,4.78-.16,7.16,.06,1.43,.17,2.49,1.41,2.44,2.85Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.84,91.79c-.14,3.99-1.67,11.77-4.85,12.61-3.42,.9-5.89,.99-11.8-.3-1.23-.19-2.46-.29-3.7-.3-.22,0-.4-.19-.4-.41,0-2.03,0-11.01,0-12.55,0-.13,.06-.25,.16-.32,.8-.57,1.29-2.07,2.15-2.85,1.63-1.46,2.87-1.89,3.97-2.72,1.88-1.42,2.22-3.22,2.82-4.63,.49-1.16,1.29-1.99,2.5-1.45,1.22,.54,2.48,2.75,.96,5.89-.44,.91-1.08,1.57-1.66,3.18-.13,.37-.16,.96,.26,.94,2.38-.18,4.78-.16,7.16,.06,1.43,.17,2.49,1.41,2.44,2.85Z",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,103.65v-13.69c0-.46-.37-.83-.83-.83H5.99c-.46,0-.83,.37-.83,.83h0v13.69c0,.46,.37,.83,.83,.83h4.44c.46,0,.83-.37,.83-.83h0Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,103.65v-13.69c0-.46-.37-.83-.83-.83H5.99c-.46,0-.83,.37-.83,.83h0v13.69c0,.46,.37,.83,.83,.83h4.44c.46,0,.83-.37,.83-.83h0Z",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.28,
    cy: 92.61,
    r: 1.25,
    style: {
      fill: "#b2dbf7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 118.95,
    cy: 16.41,
    r: 15.43,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.95,
    cy: 16.41,
    r: 11.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.95,
    cy: 16.41,
    r: 8.22,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.95,
    cy: 16.41,
    r: 4.25,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 113.45,
    y1: 124.44,
    x2: 113.45,
    y2: 116.59,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.64,
    y1: 124.44,
    x2: 117.64,
    y2: 121.04,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.82,
    y1: 124.44,
    x2: 121.82,
    y2: 118.68,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 126.01,
    y1: 124.44,
    x2: 126.01,
    y2: 121.04,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.19,
    y1: 124.44,
    x2: 130.19,
    y2: 118.68,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.98,
    y: 36.03,
    width: 6.28,
    height: 6.28,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35,
    y1: 40.73,
    x2: 126.53,
    y2: 40.73,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35,
    y1: 43.35,
    x2: 128.62,
    y2: 43.35,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35,
    y1: 38.12,
    x2: 131.76,
    y2: 38.12,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08,39.22c-.06,1.19-.5,2.35-1.34,3.2,.56,.59,1.17,.85,1.95,.98l-.17,.98c-1.03-.18-1.84-.56-2.56-1.34-.53,.33-1.04,.48-1.65,.59l-.17-.98c.46-.08,.83-.18,1.24-.42-.45-.81-.62-1.63-.64-2.55,.33,0,.66-.02,.99-.02,.02,.69,.12,1.31,.43,1.93,.58-.65,.87-1.5,.93-2.36h-3.06v-1.01h1.78v-.62h1.22v.62h1.78v1.01h-.72Z",
    style: {
      fill: "#b2dbf7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.98,
    y: 45.95,
    width: 6.28,
    height: 6.28,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35,
    y1: 50.65,
    x2: 126.53,
    y2: 50.65,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35,
    y1: 53.27,
    x2: 128.62,
    y2: 53.27,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35,
    y1: 48.04,
    x2: 131.76,
    y2: 48.04,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08,49.14c-.06,1.19-.5,2.35-1.34,3.2,.56,.59,1.17,.85,1.95,.98l-.17,.98c-1.03-.18-1.84-.56-2.56-1.34-.53,.33-1.04,.48-1.65,.59l-.17-.98c.46-.08,.83-.18,1.24-.42-.45-.81-.62-1.63-.64-2.55,.33,0,.66-.02,.99-.02,.02,.69,.12,1.31,.43,1.93,.58-.65,.87-1.5,.93-2.36h-3.06v-1.01h1.78v-.62h1.22v.62h1.78v1.01h-.72Z",
    style: {
      fill: "#b2dbf7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.98,
    y: 55.87,
    width: 6.28,
    height: 6.28,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35,
    y1: 60.58,
    x2: 126.53,
    y2: 60.58,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35,
    y1: 63.19,
    x2: 128.62,
    y2: 63.19,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35,
    y1: 57.96,
    x2: 131.76,
    y2: 57.96,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08,59.06c-.06,1.19-.5,2.35-1.34,3.2,.56,.59,1.17,.85,1.95,.98l-.17,.98c-1.03-.18-1.84-.56-2.56-1.34-.53,.33-1.04,.48-1.65,.59l-.17-.98c.46-.08,.83-.18,1.24-.42-.45-.81-.62-1.63-.64-2.55,.33,0,.66-.02,.99-.02,.02,.69,.12,1.31,.43,1.93,.58-.65,.87-1.5,.93-2.36h-3.06v-1.01h1.78v-.62h1.22v.62h1.78v1.01h-.72Z",
    style: {
      fill: "#b2dbf7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.12,
    y: 109.28,
    width: 6.28,
    height: 6.28,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.49,
    y1: 113.99,
    x2: 18.77,
    y2: 113.99,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.49,
    y1: 116.6,
    x2: 20.86,
    y2: 116.6,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.49,
    y1: 111.37,
    x2: 24,
    y2: 111.37,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22,112.47c-.06,1.19-.5,2.35-1.34,3.2,.56,.59,1.17,.85,1.95,.98l-.17,.98c-1.03-.18-1.84-.56-2.56-1.34-.53,.33-1.04,.48-1.65,.59l-.17-.98c.46-.08,.83-.18,1.24-.42-.45-.81-.62-1.63-.64-2.55,.33,0,.66-.02,.99-.02,.02,.69,.12,1.31,.43,1.93,.58-.65,.87-1.5,.93-2.36h-3.06v-1.01h1.78v-.62h1.22v.62h1.78v1.01h-.72Z",
    style: {
      fill: "#b2dbf7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.12,
    y: 121.84,
    width: 6.28,
    height: 6.28,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.49,
    y1: 126.54,
    x2: 18.77,
    y2: 126.54,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.49,
    y1: 129.16,
    x2: 20.86,
    y2: 129.16,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.49,
    y1: 123.92,
    x2: 20.86,
    y2: 123.92,
    style: {
      fill: "none",
      stroke: "#dff3fa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22,125.03c-.06,1.19-.5,2.35-1.34,3.2,.56,.59,1.17,.85,1.95,.98l-.17,.98c-1.03-.18-1.84-.56-2.56-1.34-.53,.33-1.04,.48-1.65,.59l-.17-.98c.46-.08,.83-.18,1.24-.42-.45-.81-.62-1.63-.64-2.55,.33,0,.66-.02,.99-.02,.02,.69,.12,1.31,.43,1.93,.58-.65,.87-1.5,.93-2.36h-3.06v-1.01h1.78v-.62h1.22v.62h1.78v1.01h-.72Z",
    style: {
      fill: "#b2dbf7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.18,133.33H29.48s2.38-13.55,2.38-13.55c1.53-8.73,9.11-15.09,17.97-15.09h0c8.86,0,16.44,6.37,17.97,15.09l2.38,13.55Z",
    style: {
      fill: "#5e9fe1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.83,
    cy: 92.89,
    r: 11.81,
    style: {
      fill: "#5e9fe1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8,119.79c-1.53-8.73-9.11-15.09-17.97-15.09h0c-.7,0-1.38,.04-2.06,.12,7.95,.9,14.5,6.93,15.91,14.97l2.38,13.55h4.12l-2.38-13.55Z",
    style: {
      fill: "#4194d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.83,81.08c-.85,0-1.68,.09-2.48,.26,5.33,1.14,9.33,5.87,9.33,11.54s-4,10.4-9.33,11.54c.8,.17,1.63,.26,2.48,.26,6.52,0,11.81-5.29,11.81-11.81s-5.29-11.81-11.81-11.81Z",
    style: {
      fill: "#4194d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.18,133.33H29.48s2.38-13.55,2.38-13.55c1.53-8.73,9.11-15.09,17.97-15.09h0c8.86,0,16.44,6.37,17.97,15.09l2.38,13.55Z",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.92px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.83,
    cy: 92.89,
    r: 11.81,
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.34,133.33h-40.67s-.01,0-.01-.01l2.37-13.53c1.53-8.73,9.11-15.09,17.97-15.09h0c8.86,0,16.44,6.37,17.97,15.09l2.37,13.53s0,.01-.01,.01Z",
    style: {
      fill: "#91c0db"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 92.89,
    r: 11.81,
    style: {
      fill: "#91c0db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,81.08c-.85,0-1.68,.09-2.48,.26,5.33,1.14,9.33,5.87,9.33,11.54s-4,10.4-9.33,11.54c.8,.17,1.63,.26,2.48,.26,6.52,0,11.81-5.29,11.81-11.81s-5.29-11.81-11.81-11.81Z",
    style: {
      fill: "#7ab2ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.98,119.79c-1.53-8.73-9.11-15.09-17.97-15.09h0c-.7,0-1.38,.04-2.06,.12,7.95,.9,14.5,6.93,15.91,14.97l2.38,13.55h4.12l-2.38-13.55Z",
    style: {
      fill: "#7ab2ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.35,133.33h-40.7s2.38-13.55,2.38-13.55c1.53-8.73,9.11-15.09,17.97-15.09h0c8.86,0,16.44,6.37,17.97,15.09l2.38,13.55Z",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.92px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 92.89,
    r: 11.81,
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.92px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "26.62 75.23 61.91 75.23 71.63 81.71 71.63 42.82 26.62 42.82 26.62 75.23",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.62,
    y: 42.82,
    width: 2.57,
    height: 32.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.23 42.82 66.23 78.11 71.63 81.71 71.63 42.82 66.23 42.82",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.62 75.23 61.91 75.23 71.63 81.71 71.63 42.82 26.62 42.82 26.62 75.23",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.92px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.21 65.12 72.93 65.12 63.21 71.6 63.21 32.72 108.21 32.72 108.21 65.12",
    style: {
      fill: "#5e9fe1"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.21,68.48v3.12l10.8-7.2h-3.15c-1,0-1.97,.29-2.8,.85l-4.85,3.23Z",
    style: {
      fill: "#4194d8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.53,
    y: 32.72,
    width: 4.68,
    height: 32.4,
    style: {
      fill: "#4194d8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "108.21 65.12 72.93 65.12 63.21 71.6 63.21 32.72 108.21 32.72 108.21 65.12",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.92px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 40.27,
    cy: 58.1,
    r: 2.88,
    style: {
      fill: "#5e9fe1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.91,
    cy: 58.1,
    r: 2.88,
    style: {
      fill: "#5e9fe1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.82,
    cy: 58.1,
    r: 2.88,
    style: {
      fill: "#5e9fe1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 77.93,
    cy: 48.92,
    r: 2.88,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.58,
    cy: 48.92,
    r: 2.88,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.49,
    cy: 48.92,
    r: 2.88,
    style: {
      fill: "#dff3fa"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M88.18,73.95h-1.49v-1.49h-1.49v1.49h-1.49v1.49h1.49v1.49h-2.98v-2.98h-2.98v-5.95h5.95v2.98h1.49v-1.49h1.49v1.49h1.49v4.46h-1.49v-1.49Zm-7.44-4.46v2.98h2.98v-2.98h-2.98Zm7.44-1.49h1.49v1.49h-1.49v-1.49Zm-2.98,5.95h1.49v1.49h-1.49v-1.49Zm-5.95,1.49h1.49v1.49h-1.49v-1.49Zm1.49,1.49h1.49v1.49h-1.49v-1.49Zm7.44,0h1.49v1.49h-1.49v-1.49Zm-2.98,0h1.49v1.49h-1.49v-1.49Zm-3.72-6.7h1.49v1.49h-1.49v-1.49Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.08,73.95h-1.49v-1.49h-1.49v1.49h-1.49v1.49h1.49v1.49h-2.98v-2.98h-2.98v-5.95h5.95v2.98h1.49v-1.49h1.49v1.49h1.49v4.46h-1.49v-1.49Zm-7.44-4.46v2.98h2.98v-2.98h-2.98Zm7.44-1.49h1.49v1.49h-1.49v-1.49Zm-2.98,5.95h1.49v1.49h-1.49v-1.49Zm-5.95,1.49h1.49v1.49h-1.49v-1.49Zm1.49,1.49h1.49v1.49h-1.49v-1.49Zm7.44,0h1.49v1.49h-1.49v-1.49Zm-2.98,0h1.49v1.49h-1.49v-1.49Zm-3.72-6.7h1.49v1.49h-1.49v-1.49Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.29 106.05 98.96 102.71 97.29 99.36 100.63 101.04 103.97 99.36 102.3 102.71 103.97 106.05 100.63 104.38 97.29 106.05",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.93 106.05 107.6 102.71 105.93 99.36 109.27 101.04 112.61 99.36 110.94 102.71 112.61 106.05 109.27 104.38 105.93 106.05",
    style: {
      fill: "#dff3fa"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.835ea7fffa2a23042341b885a6ceeacd.svg";
export { ForwardRef as ReactComponent };